export enum Colors {

  WHITE = "#ffffff",
  BLACK = "#333333",
  GRAY = "#aaaaaa",

  BLUE = "#4398D9",
  RED = "#ed1b23",
  GREEN = "#1CA944",
  ORANGE = "#ff661a",
  PURPLE = "#7834ca",
  NEON = "#61CBD6",
  BROWN = "#704e37",

  BLACK_V1 = "#3F4852",
  BLUE_V1 = "#438ECC",
  BLUE_V2 = "#3ebce5",
  BLUE_V3 = "#3378f6",
  GRAY_V1 = "#717981",
  GRAY_V2 = "#6B7F94",
  GRAY_V3 = "#F6F6F6",
  GRAY_V4 = "#E2E2E2",
  GRAY_V5 = "#747474",
  GRAY_V6 = "#F1F1F1",
  GRAY_V7 = "#4D4D4D",
  GRAY_V8 = "#808080",
  GRAY_V9 = "#5D6476",
  GRAY_V10 = "#a08b78",
  NEON_V1 = "#8eccdf",
  NEON_V2 = "#c8f9ff",
  NEON_V3 = "#C5E7F2",
  NEON_V4 = "#5abdd7",
  GREEN_V1 = "#448691",
  GREEN_V2 = "#398072",
  GREEN_V3 = "#16b497",
  PURPLE_V1 = "#a05af1",
  PURPLE_V2 = "#9144c9",
  RED_V1 = "#fe8282",
  RED_V2 = "#f56f6f",
  BROWN_V1 = "#93694c",

  DARK_BLUE = "#000570",
  DARK_GREEN = "#026b15",
  DARK_RED = "#B24025",
  DARK_ORANGE = "#F94C44",
  DARK_GRAY = "#565656",
  DARK_NEON = "#1f99c0",

  DARK_BLUE_V1 = "#20212a",
  DARK_BLUE_V2 = "#1babd4",
  DARK_GREEN_V1 = "#0f826d",

  LIGHT_BLUE = "#e2ebff",
  LIGHT_GRAY = "#b1b1b1",
  LIGHT_RED = "#FBF4F2",
  LIGHT_GREEN = "#79d279",
  LIGHT_ORANGE = "#ffccb3",
  LIGHT_NEON = "#e1fcff",
  LIGHT_PURPLE = "#975edb",
  
  LIGHT_BLUE_V1 = "#dceef7",
  LIGHT_BLUE_V2 = "#a2e7fe",
  LIGHT_BLUE_V3 = "#6bd6f7",
  LIGHT_PURPLE_V1 = "#c19cec",
  LIGHT_PURPLE_V2 = "#c592ff",
  LIGHT_PURPLE_V3 = "#a15cf2",
  LIGHT_GREEN_V1 = "#98f7e6",
  LIGHT_BROWN_V1 = "#ebcaaa",
  LIGHT_BROWN_V2 = "#f0c9a6",

  EXTRA_LIGHT_BLUE = "#EDFAFF",
  EXTRA_LIGHT_GREEN = "#DCEDDD",
  EXTRA_LIGHT_GRAY = "#E5EBF0",
  EXTRA_LIGHT_RED = "#FCD1D3",
  EXTRA_LIGHT_PURPLE = "#e8d4ff",
  EXTRA_LIGHT_BROWN = "#f8f2ed",

  EXTRA_LIGHT_BLUE_V1 = "#f6faff",
  EXTRA_LIGHT_PURPLE_V1 = "#f1f1ff",
  EXTRA_LIGHT_BROWN_V1 = "#fcfbf1",

  TRANSPARENT = "rgba(0, 0, 0, 0)",
  TRANSPARENT_SHADOW_1 = "rgba(0,0,0,0.1)",
  TRANSPARENT_SHADOW_2 = "rgba(0,0,0,0.2)",
  TRANSPARENT_SHADOW_3 = "rgba(0,0,0,0.3)",
  TRANSPARENT_SHADOW_5 = "rgba(0,0,0,0.5)",
  TRANSPARENT_SHADOW_8 = "rgba(0,0,0,0.8)",
  TRANSPARENT_SHADOW_LIGHT_1 = "rgba(255,255,255,0.1)",
  TRANSPARENT_SHADOW_LIGHT_3 = "rgba(255,255,255,0.3)",
  TRANSPARENT_SHADOW_LIGHT_5 = "rgba(255,255,255,0.5)",
  TRANSPARENT_SHADOW_LIGHT_8 = "rgba(255,255,255,0.8)",

  LIGHT_MODE_TEXT_COLOR = BLACK,
  LIGHT_MODE_BG_COLOR = WHITE,

  DARK_MODE_TEXT_COLOR = WHITE,
  DARK_MODE_BG_COLOR = BLACK

}